import React, { useEffect, useState } from 'react'
import { Button, Offcanvas} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useAuth } from '../auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { getNotifications, removeNotifications } from '../../actions/other/notificationsActions'
import Swal from 'sweetalert2'
import { Link } from 'react-router-dom'

export default function MenuMovil({showCanvas, setShowCanvas: setShowCanvasProp}) {
	const { t } = useTranslation()
    const { clientauth } = useAuth()
    const dispatch = useDispatch()

    const {notifications} = useSelector(state=>state.notifications)

    const [selectedNotifications, setSelectedNotifications] = useState([])
    const [selectAllNotifications, setSelectAllNotifications] = useState(false)

    const toggleNotification = (id) => {
        setSelectedNotifications(prev =>
            prev.includes(id) ? prev.filter(nid => nid !== id) : [...prev, id]
        )
    }

    const toggleSelectAllNotifications = () => {
        if (selectAllNotifications) {
            setSelectedNotifications([])
        } else {
            setSelectedNotifications(notifications.filter(n => !n.read).map(n => n._id))
        }
        setSelectAllNotifications(!selectAllNotifications)
    }

    const handleRemoveNotifications = () => {
        if (selectedNotifications.length === 0) return

        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.accept'),
            denyButtonText: t('global.cancel'),
            icon: 'warning',
            html: t('employee.notification.areyousureread')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeNotifications(selectedNotifications))
                setSelectedNotifications([])
                setSelectAllNotifications(false)
            }
        })
    }

    const NOTIFICATION_ROUTES = {
        calendar: t("url.employee.calendar")
    }

    useEffect(() => {
        if(clientauth){
            dispatch(getNotifications(clientauth?.employee))
        }
    },[dispatch, t, clientauth])

  	return (
        <Offcanvas show={showCanvas} onHide={() => setShowCanvasProp(false)} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title><h3>{t('menus.notifications')}</h3></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {notifications.length > 0 ?
                    <>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className='py-2'>
                                <input
                                    type="checkbox"
                                    checked={selectAllNotifications}
                                    onChange={toggleSelectAllNotifications}
                                    className="form-check-input me-2"
                                />
                                <label>{t('employee.notification.selectAll')}</label>
                            </div>
                            {selectedNotifications.length > 0 &&
                                <Button variant='small' type="button"
                                    onClick={handleRemoveNotifications}>
                                    <small>{t('employee.notification.readAll')}</small>
                                </Button>
                            }
                        </div>
                        {notifications.filter(notification => !notification.read).sort((a, b) => new Date(b.date) - new Date(a.date)).map(notification => (
                            <div className="d-flex justify-content-between align-items-center border-bottom py-2" key={notification._id}>
                                <div className='d-flex align-items-start'>
                                    <input
                                        type="checkbox"
                                        className="form-check-input me-2 mt-1 check-notifications"
                                        checked={selectedNotifications.includes(notification._id)}
                                        onChange={() => toggleNotification(notification._id)}
                                    />
                                    <div>
                                        {notification.type ?
                                            <Link to={NOTIFICATION_ROUTES[notification.type]} className='notification-container'>
                                                <div className='fw-bold'>
                                                    {t('employee.notification.'+notification.type)} - {new Intl.DateTimeFormat('es-ES', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false}).format(new Date(notification.date))}
                                                </div>
                                                <small dangerouslySetInnerHTML={{ __html: notification.message }} />
                                            </Link>
                                        :
                                            <div>
                                                <div className='fw-bold'>
                                                    {new Intl.DateTimeFormat('es-ES', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false}).format(new Date(notification.date))}
                                                </div>
                                                <small dangerouslySetInnerHTML={{ __html: notification.message }} />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        ))}
                    </>
                :
                    <div className='text-center'><h4 className='font-general'>{t('menus.noNotifications')}</h4></div>
                }
            </Offcanvas.Body>
        </Offcanvas>
	)
}
